virtual task body();
  super.body();

  repeat ({{ numTransactionsVariable.identifier }}) begin
    {{> (partial "uvc-virtual-sequence/granted-request") context=. waitForGrantMethodName="wait_for_request_grant" retireGrantMethodName="retire_request_grant" writeItemMethodName="write_request_item" requestOrDataSequenceHandle=requestSequenceHandle}}
  end
endtask
